module.exports = __webpack_public_path__ + "static/f2p-d6b848e73f4f962624147b765e73b33b.png";